import { useEffect, useState } from 'react'
import { Button, Col, ConfigProvider, Form, Input, message, Row, Select } from 'antd'

import styles from '../index.module.less'
import { SFuncModal } from 'shj-components'
import {
  uCenterSendPhoneCode,
  uCenterUpdatePassword,
  uCenterVerifyPhoneCode,
  updatePasswordByPhoneValidate,
} from '@/services'
import useValidate from '@/hooks/useValidate.ts'
import PasswordInput from '@/components/PasswordInput'
import { useSetState } from 'ahooks'

interface IProps {
  data: any
  onClose: () => void
}

const EditPasswordForm = (props: IProps) => {
  const { onClose, data } = props
  const [validateHelper] = useValidate()
  const [form] = Form.useForm()
  const [validateForm] = Form.useForm()

  const [isGetting, setIsGetting] = useState<boolean>(false)
  const [waitingTime, setWaitingTime] = useState<number>(60)
  const [sendCodeLoading, setSendCodeLoading] = useState<boolean>(false)
  const [state, setState] = useSetState<any>({
    step: 0,
    validateCode: '',
    submitLoading: false,
  })

  useEffect(() => {
    form.resetFields()
    form.setFieldsValue(props.data)
    validateForm.setFieldsValue(props.data)
  }, [props.data])

  useEffect(() => {
    let timer
    if (isGetting) {
      timer = setTimeout(() => {
        if (waitingTime > 0) {
          setWaitingTime(waitingTime - 1)
        } else {
          setIsGetting(false)
        }
        timer && clearTimeout(timer)
      }, 1000)
    } else {
      timer && clearTimeout(timer)
      setWaitingTime(60)
    }
  }, [isGetting, waitingTime])

  const onFinish = (): Promise<void> => {
    return new Promise((resolve, reject) => {
      if (state.step === 0) {
        validateForm
          .validateFields()
          .then(values => {
            setState({ submitLoading: true })
            return uCenterVerifyPhoneCode({ code: values['code'] }).finally(() =>setState({ submitLoading: false }))
          })
          .then(code => {
            setState({ step: 1, validateCode: code, submitLoading: false })
            resolve()
          })
      } else {
        form
          .validateFields()
          .then(values => {
            updatePasswordByPhoneValidate({
              newPassword: values['newPassword'],
              code: state.validateCode,
            }).then(() => {
              message.success('操作成功')
              onClose()
              resolve()
            })
            // uCenterUpdatePassword(values).then(() => {
            //   message.success('操作成功')
            //   onClose()
            //   resolve()
            // })
          })
          .catch(reject)
      }
    })
  }

  const onGetCheckCode = () => {
    form.validateFields(['phone']).then(() => {
      setSendCodeLoading(true)
      // uCenterSendPhoneCode({phone: data.phone})
      uCenterSendPhoneCode({ phone: data.phone })
        .then(() => {
          setIsGetting(true)
          setSendCodeLoading(false)
        })
        .catch(() => {
          setIsGetting(false)
          setSendCodeLoading(false)
        })
    })
  }

  const prefixSelector = (
    <Form.Item name="prefix" noStyle>
      <Select defaultValue={'86'} style={{ width: 100 }} disabled>
        <Select.Option value="86">+86</Select.Option>
      </Select>
    </Form.Item>
  )

  return (
    <SFuncModal.Content
      okText={state.step === 0 ? '下一步' : '保存'}
      onOk={onFinish}
      onCancel={onClose}
      confirmLoading={state.submitLoading}
    >
      <Form
        form={validateForm}
        layout={'vertical'}
        style={{ display: state.step == 0 ? 'revert' : 'none' }}
      >
        <Form.Item
          label={'当前手机号'}
          name={'phone'}
          rules={[
            { required: true, message: '手机号不能为空' },
            {
              pattern: /^1[\d]{10}/,
              message: '请输入正确格式的手机号',
            },
          ]}
        >
          <Input
            readOnly
            placeholder={'请输入当前手机号'}
            maxLength={11}
            minLength={11}
            addonBefore={prefixSelector}
            style={{ width: '100%' }}
          />
        </Form.Item>
        <Row>
          <Col span={18}>
            <Form.Item
              name="code"
              label={'验证码'}
              className={styles.mb_0}
              rules={[{ required: true, message: '验证码不能为空' }]}
            >
              <Input
                style={{ borderTopRightRadius: 0, borderBottomRightRadius: 0 }}
                placeholder="请输入验证码"
              />
            </Form.Item>
          </Col>
          <Col span={6}>
            <ConfigProvider
              theme={{
                components: {
                  Button: {
                    defaultBg: '#fafafa',
                    defaultActiveBg: '#fafafa',
                    defaultHoverBg: '#fafafa',
                    defaultActiveBorderColor: '#d9d9d9',
                    defaultHoverBorderColor: '#d9d9d9',
                    defaultActiveColor: '#000000e0',
                    defaultHoverColor: '#000000e0',
                  },
                },
              }}
            >
              <Button
                className={styles.right_code_btn}
                block
                onClick={onGetCheckCode}
                disabled={isGetting}
                loading={sendCodeLoading}
              >
                {!isGetting ? '获取验证码' : `${waitingTime} s`}
              </Button>
            </ConfigProvider>
          </Col>
        </Row>
      </Form>
      <Form
        form={form}
        layout={'vertical'}
        style={{ display: state.step == 1 ? 'revert' : 'none' }}
      >
        {/*<Form.Item*/}
        {/*  name="oldPassword"*/}
        {/*  label="原密码"*/}
        {/*  rules={[*/}
        {/*    {*/}
        {/*      required: true,*/}
        {/*      message: '请输入原密码',*/}
        {/*    },*/}
        {/*  ]}*/}
        {/*>*/}
        {/*  <PasswordInput placeholder={'请输入原密码'} />*/}
        {/*</Form.Item>*/}

        <Form.Item name="newPassword" label="新密码" rules={[validateHelper.password('confirm')]}>
          <PasswordInput placeholder={'请输入新密码'} autoComplete="new-password" />
        </Form.Item>

        <Form.Item
          className={styles.mb_0}
          name="confirm"
          label="确认密码"
          // dependencies={['newPassword']}
          rules={[validateHelper.password('newPassword', { message: '请确认新密码' })]}
        >
          <PasswordInput placeholder={'请再次输入新密码'} />
        </Form.Item>
      </Form>
    </SFuncModal.Content>
  )
}

export default EditPasswordForm
